"use strict";
/** state: Final **/
/** family: Input **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var keycode = require("keycode");
var React = require("react");
var icon_types_1 = require("../../types/icon.types");
var FontAwesome_1 = require("../FontAwesome");
var Input_1 = require("../Input");
var utils_1 = require("../utils");
var CLASS_NAME = 'i-input-group';
var AddonPosition;
(function (AddonPosition) {
    AddonPosition["Appended"] = "appended";
    AddonPosition["Prepended"] = "prepended";
})(AddonPosition = exports.AddonPosition || (exports.AddonPosition = {}));
var InputAddon = (function (_a) {
    var addonRef = _a.addonRef, className = _a.className, children = _a.children, watermark = _a.watermark, restProps = __rest(_a, ["addonRef", "className", "children", "watermark"]);
    var _b;
    var addonClassName = 'input-group-addon';
    return (React.createElement("span", __assign({ ref: addonRef, className: classNames(addonClassName, className, (_b = {},
            _b[addonClassName + "--watermark"] = watermark,
            _b)) }, restProps), children));
});
exports.InputAddon = InputAddon;
InputAddon.Position = AddonPosition;
/**
 * Container for rendering `Input` and `InputAddon` components.
 *
 * Components are displayed the order in which they are declared.
 */
var InputGroup = /** @class */ (function (_super) {
    __extends(InputGroup, _super);
    function InputGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFocus = function () {
            _this.setState({ isFocused: true });
        };
        _this.handleBlur = function () {
            _this.setState({ isFocused: false });
        };
        _this.state = {
            isFocused: false,
        };
        return _this;
    }
    InputGroup.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, clearable = _b.clearable, disabled = _b.disabled, loading = _b.loading, onClear = _b.onClear, restProps = __rest(_b, ["children", "className", "clearable", "disabled", "loading", "onClear"]);
        var _c = this.getContent(children, !!clearable, disabled, loading, onClear), content = _c.content, readOnly = _c.readOnly, type = _c.type, watermarkAppendedAddon = _c.watermarkAppendedAddon, watermarkPrependedAddon = _c.watermarkPrependedAddon;
        var classes = classNames(CLASS_NAME, className, 'input-group', (_a = {},
            _a[CLASS_NAME + "--disabled"] = disabled,
            _a[CLASS_NAME + "--read-only"] = readOnly,
            _a[CLASS_NAME + "--focus"] = this.state.isFocused,
            _a[CLASS_NAME + "--prepended-watermark"] = watermarkPrependedAddon,
            _a[CLASS_NAME + "--appended-watermark"] = watermarkAppendedAddon,
            _a[CLASS_NAME + "--range"] = type === Input_1.InputType.Range,
            _a));
        return (React.createElement("div", __assign({ className: classes }, restProps), content));
    };
    InputGroup.prototype.handleClearIconKeyDown = function (e, onClear) {
        if (e.keyCode === keycode('Enter') || e.keyCode === keycode('Space')) {
            onClear(e);
        }
    };
    InputGroup.prototype.getAddon = function (child, position, index) {
        var _a;
        var _b = child.props, className = _b.className, restProps = __rest(_b, ["className"]);
        var addonClassName = 'input-group-addon';
        var classes = classNames((_a = {
                'input-group-append': position === AddonPosition.Appended
            },
            _a[addonClassName + "--appended"] = position === AddonPosition.Appended,
            _a['input-group-prepend'] = position === AddonPosition.Prepended,
            _a[addonClassName + "--prepended"] = position === AddonPosition.Prepended,
            _a));
        return (React.createElement("div", { className: classes, key: index },
            React.createElement(child.type, __assign({ className: classNames(className, 'input-group-text') }, restProps))));
    };
    InputGroup.prototype.getContent = function (children, clearable, disabled, loading, onClear) {
        var _this = this;
        // Used to set css class on the container.
        var watermarkPrependedAddon = false;
        var watermarkAppendedAddon = false;
        var readOnly = false;
        var type = null;
        var showClearIcon = false;
        var content = [];
        React.Children.forEach(children, function (child, index) {
            if (!child) {
                return;
            }
            if (utils_1.isType(child, Input_1.Input)) {
                content.push(React.createElement(Input_1.Input, __assign({}, child.props, { disabled: disabled, key: index, onBlur: function (e) {
                        _this.handleBlur();
                        child.props.onBlur && child.props.onBlur(e);
                    }, onFocus: function (e) {
                        _this.handleFocus();
                        child.props.onFocus && child.props.onFocus(e);
                    } })));
                readOnly = child.props.readOnly;
                type = child.props.type;
                showClearIcon = clearable && !!child.props.value;
                // If the InputGroup doesn't have any appended Addons, and
                // we should show a loading/clear icon, append it here.
                if ((loading || showClearIcon) &&
                    React.Children.count(children) === index + 1) {
                    watermarkAppendedAddon = true;
                    if (loading) {
                        content.push(_this.getLoadingIconAddon(index + 1));
                    }
                    else {
                        content.push(_this.getClearIconAddon(onClear, index + 1));
                    }
                }
            }
            if (utils_1.isType(child, InputAddon)) {
                if (content.length === 0) {
                    content.push(_this.getAddon(child, AddonPosition.Prepended, index));
                    if (child.props.watermark) {
                        watermarkPrependedAddon = true;
                    }
                }
                else {
                    // Replace appended addon with a loading/clear icon.
                    if (loading) {
                        watermarkAppendedAddon = true;
                        content.push(_this.getLoadingIconAddon(index));
                    }
                    else if (showClearIcon) {
                        watermarkAppendedAddon = true;
                        content.push(_this.getClearIconAddon(onClear, index));
                    }
                    else {
                        content.push(_this.getAddon(child, AddonPosition.Appended, index));
                        if (child.props.watermark) {
                            watermarkAppendedAddon = true;
                        }
                    }
                }
            }
        });
        return {
            content: content,
            readOnly: readOnly,
            type: type,
            watermarkAppendedAddon: watermarkAppendedAddon,
            watermarkPrependedAddon: watermarkPrependedAddon,
        };
    };
    InputGroup.prototype.getClearIconAddon = function (onClear, key) {
        var _this = this;
        var addonClassName = 'input-group-addon';
        return this.getAddon(React.createElement(InputAddon, { watermark: true },
            React.createElement("span", { "aria-label": this.props.clearable, className: addonClassName + "__clear", onClick: onClear, onKeyDown: function (e) {
                    return _this.handleClearIconKeyDown(e, onClear);
                }, tabIndex: 0 },
                React.createElement(FontAwesome_1.FontAwesome, { name: icon_types_1.Icon.Clear }))), AddonPosition.Appended, key);
    };
    InputGroup.prototype.getLoadingIconAddon = function (key) {
        var appendedAddonClassName = 'input-group-addon--appended';
        var classes = classNames(appendedAddonClassName, appendedAddonClassName + "__loading");
        return (React.createElement(InputAddon, { key: key, className: classes, watermark: true },
            React.createElement(FontAwesome_1.FontAwesome, { name: icon_types_1.Icon.Loading, spin: true })));
    };
    InputGroup.Addon = InputAddon;
    return InputGroup;
}(React.Component));
exports.InputGroup = InputGroup;
//# sourceMappingURL=InputGroup.js.map